export const NOOP = ( ...args: any[] ): void => { /** empty */ };
